import uuid from 'uuid';

export default function emptyRule() {
  return {
    id: uuid.v4()
  };
}



// WEBPACK FOOTER //
// ./src/apps/Products/util/emptyRule.js